import { useContext } from "react";

import { AuthContext, type AuthContextValue } from "./AuthProvider";

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth() yalnizca <AuthProvider> icinde kullanilabilir");
  }
  return ctx;
}
